module.exports = System._nodeRequire ? process : require('process');